import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material';
import FormComponent from '../../FormComponent/FormComponent.tsx';

function ShopperExperience() {
    const [ratings, setRatings] = useState<{ id: number; value: number, label: string }[]>([]);

    useEffect(() => {
        // Simulated API data
        const fetchRatings = async () => {
            const response = [
                { id: 1, value: 3, label: 'Bar rating' },
                { id: 2, value: 4, label: 'Service rating' },
                { id: 3, value: 2, label: 'Product quality' },
                { id: 4, value: 5, label: 'Customer support' },
                { id: 5, value: 3, label: 'Delivery speed' },
                { id: 6, value: 4, label: 'Pricing' },
                { id: 7, value: 5, label: 'Website experience' },
                { id: 8, value: 2, label: 'Overall experience' },
            ];
            setRatings(response);
        };

        fetchRatings();
    }, []);

    const handleRatingChange = (id: number, newValue: number | null) => {
        setRatings((prevRatings) =>
            prevRatings.map((rating) =>
                rating.id === id ? { ...rating, value: newValue ?? 0 } : rating
            )
        );
    };

    return (
        <Box className="container p-3">
            
            <Box className="row">
                {ratings.map((rating) => (
                    <Box key={rating.id} className="col-md-4 col-sm-6 col-12 mb-3">
                        <FormComponent
                            FormDetail={{
                                type: "rating",
                                value: rating.value,
                                label: rating.label,
                                setValue: (newValue: number) => handleRatingChange(rating.id, newValue),
                            }}
                        />
                    </Box>
                ))}
                <FormComponent FormDetail={{
                    type: "divider",
                    value: null,
                    label: null,
                    setValue: null
                }} />
            </Box>
        </Box>
    )
}

export default ShopperExperience
